import { Text } from '@afterpaytouch/core'
import React, { FunctionComponent } from 'react'
import { usePBIUnavailable } from '../../../../state'
import { usePBIAPRText, usePBIDueTodayText, usePBIEveryText } from '../../helper'
import styles from './style.module.css'
import { useCheckoutSizes } from '../../../../utils/responsive'

export const PayInFourRadioLabel: FunctionComponent = () => {
  const isPbiUnavailable = usePBIUnavailable()
  const { textSize } = useCheckoutSizes()

  const paymentsTextDueToday = usePBIDueTodayText()
  const paymentIntervalTextPBI = usePBIEveryText()
  const paymentAPRInterestPBI = usePBIAPRText()

  return (
    <div>
      <div className={styles.headingText}>
        <Text bold size={textSize} color={isPbiUnavailable ? 'Gray60' : 'Black'}>
          {paymentIntervalTextPBI}
        </Text>
      </div>
      <div className={styles.downPaymentText}>
        {!isPbiUnavailable && (
          <Text size={textSize} color={isPbiUnavailable ? 'Gray80' : 'Gray50'}>
            {paymentsTextDueToday}
          </Text>
        )}
      </div>
      <div className={styles.interestText}>
        <Text size={textSize} color={isPbiUnavailable ? 'Gray80' : 'Gray50'}>
          {paymentAPRInterestPBI}
        </Text>
      </div>
    </div>
  )
}
